import { observer } from 'mobx-react-lite'
import { IncompleteConsultationCompletionDialog } from '@/features/jobs/details/components/IncompleteConsultationCompletionDialog'
import { type IncompleteConsultationCompletionDialogViewModel } from './IncompleteConsultationCompletionDialogViewModel'

export interface IncompleteConsultationCompletionDialogContainerProps {
  vm: IncompleteConsultationCompletionDialogViewModel
}

export const IncompleteConsultationCompletionDialogContainer = observer(
  function IncompleteConsultationCompletionDialogContainer({
    vm,
  }: IncompleteConsultationCompletionDialogContainerProps) {
    return (
      <IncompleteConsultationCompletionDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        reason={vm.reason}
        onReasonChange={vm.setReason}
        otherText={vm.otherText}
        onOtherTextChange={vm.setOtherText}
        isValid={vm.isValid}
        onSubmit={vm.submit}
      />
    )
  },
)
